var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _circle3, _circle4, _path8, _circle5, _circle6, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 69,
    viewBox: "0 0 40 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8075 49.2722C0.389157 49.2722 1.14092 64.3513 1.14092 70.3836H37.6018C37.6018 62.2402 37.2259 49.2722 18.8075 49.2722Z",
    fill: "#323941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 35.763H22.8877V51.7565C22.8877 51.7565 22.248 53.11 19.0493 53.11C15.8506 53.11 15.2109 51.7565 15.2109 51.7565V35.763Z",
    fill: "#E59780"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.865,
    cy: 25.4156,
    rx: 2.55896,
    ry: 4.23838,
    transform: "rotate(8.66736 35.865 25.4156)",
    fill: "#E3827E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.4161,
    cy: 25.5268,
    rx: 2.55896,
    ry: 4.47818,
    transform: "rotate(-10.3706 3.4161 25.5268)",
    fill: "#E3827E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 23C35.5 39 24.8523 45.5 19 45.5C13.1477 45.5 3.99999 39 4 21.5C4 11.4304 10.803 7.52637 19.4593 7.52637C28.1156 7.52637 34.5 12.9304 34.5 23Z",
    fill: "#F5B5A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4548 29.1328C18.6274 29.2529 17.108 29.7095 17.6495 30.5744C18.1911 31.4394 19.0787 30.9348 19.4548 30.5744",
    stroke: "#AD6B68",
    strokeWidth: 0.455963,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65515 25.8459L3.69554 25.5263V22.0077C3.16242 19.5555 1.77633 19.1289 1.45646 14.011C0.997092 6.66113 9.83705 3.77563 17.7698 1.21668C25.7026 -1.34227 33.4434 5.3752 32.164 9.53283C36.2583 9.27694 40.1607 19.7686 35.0428 22.6472V26.4856H34.0832V22.6472C34.403 17.8494 27.046 22.0074 28.6454 14.3307C26.0864 16.25 11.6923 10.4924 10.4128 15.2905C9.38922 19.1289 6.68099 21.1547 4.65515 21.368V25.8459Z",
    fill: "#323941"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3571,
    cy: 24.3568,
    r: 1.78571,
    fill: "#34393C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8036,
    cy: 23.9101,
    r: 0.446429,
    fill: "#8C9AA3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6785 21.2576C10.6785 21.2576 13.1338 18.8024 15.5892 19.7844",
    stroke: "#444D56",
    strokeWidth: 0.651376,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.339 20.9988C28.339 20.9988 25.8837 18.5436 23.4284 19.5256",
    stroke: "#444D56",
    strokeWidth: 0.651376,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8571,
    cy: 24.3564,
    r: 1.78571,
    fill: "#34393C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3036,
    cy: 23.9099,
    r: 0.446429,
    fill: "#8C9AA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5713 35.0262C16.7171 36.5085 19.6963 38.5837 22.4462 35.0262",
    stroke: "#444D56",
    strokeWidth: 0.651376,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8523,
    cy: 30.0706,
    r: 1.91922,
    fill: "#FF9692"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5977,
    cy: 30.0706,
    r: 1.91922,
    fill: "#FF9692"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3053 51.1904C13.1846 52.1485 13.8122 54.122 17.288 54.3519C21.6328 54.6394 24.1672 53.2023 24.1672 52.0527",
    stroke: "white",
    strokeWidth: 0.651376,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.8abbedafbfa39ccbad578d042b013b15.svg";
export { ForwardRef as ReactComponent };